import { render, staticRenderFns } from "./LastComms.vue?vue&type=template&id=03a447aa&"
import script from "./LastComms.vue?vue&type=script&lang=js&"
export * from "./LastComms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports